import React, { useEffect, useState } from "react";
import ToggleDetails from "./ToggleDetails";
import { useDispatch, useSelector } from "react-redux";
import General from "./General";
import Layout from "./Layout";
import Stock from "./Stock";


function Dashboard() {
  const Status = useSelector(
    (state) => state.scan.WarehouseStatsToggleStatus
  );
  return (
    <>
      <div className="flex flex-col max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div>
          <h2 className="font-Montserrat text-xl font-bold text-black">
           Warehouse details
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>
        </div>
        
       
        <ToggleDetails />
        {Status === "General" ? <General /> : null}
        {Status === "Layout" ? <Layout /> : null}
        {Status === "Stock" ? <Stock /> : null}

      </div>
    </>
  );
}

export default Dashboard;
